import {
  Modal,
  ModalOverlay,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Text,
  Input,
  Button,
} from '@chakra-ui/react';
import { useState, useRef } from 'react';
import { debounce } from 'lodash-es';
import { useStopCandidateMutation } from '@/store/query/mco-candidates';
import { useShowToast } from '@/hooks/useShowToast';

export const StopConfirmation = ({
  isOpen = false,
  onClose = () => {},
  contact = {},
  outreach = {},
}) => {
  const [stopText, setStopText] = useState(null);
  const inputRef = useRef();
  const onChange = debounce(() => {
    setStopText(inputRef?.current?.value);
  }, 300);

  const toast = useShowToast();
  const [stopCandidate, { isLoading }] = useStopCandidateMutation();

  const onStop = async () => {
    try {
      const result = await stopCandidate({
        outreachId: outreach?.id,
        candidates: [contact?.id],
      });
      if (result?.error) {
        toast({
          description: 'Unable to stop the Candidate',
          position: 'bottom-left',
          status: 'error',
        });
        onClose();
        return;
      }
      toast({
        description: 'Candidate Stopped',
        position: 'bottom-left',
        status: 'success',
      });
      onClose();
    } catch {
      /* noop */
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent w="440px">
        <ModalCloseButton />
        <ModalHeader>
          <Text size="lg-semi-bold">Stop selected users?</Text>
        </ModalHeader>
        <ModalBody>
          <Flex flexDir="column">
            <Text color="#16161680">
              User will not be part of this Flow anymore and any scheduled step
              will not be sent
            </Text>
            <Input
              placeholder='Type "STOP" to confirm'
              ref={inputRef}
              onChange={onChange}
              mt="16px"
              data-test-id="flow-restart-action-stop-input"
            />
            <Flex justifyContent="space-between" my="12px">
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button
                bg="#E31B54"
                _hover={{}}
                isDisabled={stopText !== 'STOP'}
                onClick={onStop}
                isLoading={isLoading}
                data-test-id="flow-restart-action-stop-cta"
              >
                Stop
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
